const GEOLOCATION_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 60_000,
  timeout: 20_000,
};

export const getCurrentPosition = (): Promise<GeolocationPosition> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, GEOLOCATION_OPTIONS);
  });

export const isGeolocationPositionError = (error: unknown): error is GeolocationPositionError =>
  typeof error === 'object' && error !== null && 'code' in error;
